import { ChevronLeftIcon } from '@chakra-ui/icons';

import { useMovimentacaoFundos } from '../hooks/useMovimentacaoFundos';
import { LayoutMovimentacaoFundosType } from '../types/MovimentacaoFundosType';
import { formatMoney } from '../utils/formatMoney';

export const LayoutMovimentacaoFundos = ({
  navigate,
  offerContent,
  children
}: LayoutMovimentacaoFundosType) => {
  const { state } = useMovimentacaoFundos();

  return (
    <div className="tw-flex tw-flex-col tw-items-center">
      <div className="tw-w-full tw-max-w-6xl tw-px-4 tw-sm:px-6 tw-lg:px-8 tw-py-6">
        <a
          onClick={() => {
            navigate();
          }}
          className="tw-flex tw-items-center tw-cursor-pointer tw-text-[#00335E] tw-font-bold"
        >
          <ChevronLeftIcon />
          <p>Voltar</p>
        </a>
      </div>
      <div className="tw-w-full tw-max-w-6xl tw-p-5 tw-bg-white tw-rounded-lg tw-shadow-md tw-mb-5">
        <h2 className="tw-text-lg tw-font-semibold tw-text-[#00335E]">
          {state.nome_produto}
        </h2>
        <hr className="tw-my-4 tw-border-gray-300" />
        <div
          data-testid={
            offerContent && `proposta: ${offerContent.numero_proposta}`
          }
        >
          {offerContent ? (
            <div className="tw-flex tw-justify-between">
              <div className="tw-flex tw-gap-1">
                <p className="tw-text-[#00335E] tw-font-bold tw-text-base tw-lg:text-lg tw-leading-6">
                  Proposta:
                </p>

                <p className="tw-text-[#FF5000]  tw-font-bold tw-text-base tw-lg:text-lg tw-leading-6">
                  {offerContent.numero_proposta} | &nbsp;
                  {offerContent.nome_cliente}
                </p>
              </div>
              <div className="tw-flex tw-gap-1">
                <p className="tw-text-[#323232]  tw-font-bold tw-text-base tw-lg:text-lg tw-leading-6">
                  Saldo da proposta:
                </p>
                <p className="tw-text-[#006217] tw-font-bold tw-text-base tw-lg:text-lg tw-leading-6">
                  {formatMoney(String(offerContent.valor_proposta.toFixed(2)))}
                </p>
              </div>
            </div>
          ) : (
            <div className="tw-flex tw-gap-1">
              <p className="tw-text-[#00335E] tw-font-bold tw-text-base tw-lg:text-lg tw-leading-6">
                Fundo:
              </p>
              <p className="tw-text-[#FF5000]  tw-font-bold tw-text-base tw-lg:text-lg tw-leading-6">
                {state.nome_fundo}
              </p>
            </div>
          )}
        </div>
      </div>
      {children}
    </div>
  );
};
